module.exports = __webpack_public_path__ + "img/specials-multislider-6040--lincoln.a24c89ff.jpeg";